import React, { FC } from 'react';

type Props = {
  data: { [key: string]: string | number };
};

export const TableInfoPanel: FC<Props> = ({ data }) => {
  return (
    <div className="flex flex-row gap-5 flex-wrap">
      {Object.entries(data).map(([key, value]) => {
        return (
          <div key={key} className="">
            <p className="text-xs text-primary">
              <span className="font-semibold">{key} : </span> {value}
            </p>
          </div>
        );
      })}
    </div>
  );
};
